import AppLayout from '@/layout/AppLayout.vue'

const BiFund = () => import('@/view/bifund/BiFund.vue')
const BiFundDetail = () => import('@/view/bifund/detail/BiFundDetail.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/bffund',
        component: BiFund,
        meta: { key: 'bifund', header: 'coinStock' },
      },
      {
        path: '/bffund/detail/:assetId',
        component: BiFundDetail,
        meta: { key: 'bifund', header: 'coinStock' },
      },
    ],
  },
]

const components = {}

export default {
  routes,
  components,
}
